import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './shared/layout/app-layout';
import { AuthGuard } from './shared/guards/AuthGuard';
import { SettingsPage } from './pages/settings-page';
import { SecurityPage } from './pages/security-page';
import { ProfilePage } from './modules/profile/presentation/pages/ProfilePage';
import { SignInPage } from './modules/auth/presentation/pages/SignInPage';
import { ForgotPasswordPage } from './modules/auth/presentation/pages/ForgotPasswordPage';
import { SetPasswordPage } from './modules/auth/presentation/pages/SetPasswordPage';
import { ResetPasswordPage } from './modules/auth/presentation/pages/ResetPasswordPage';
import { ChangePasswordRequiredPage } from './modules/auth/presentation/pages/ChangePasswordRequiredPage';
import { VerifyEmailPage } from './modules/auth/presentation/pages/VerifyEmailPage';
import { SubmitNewEmailPage } from './modules/auth/presentation/pages/SubmitNewEmailPage';
import { ConfirmEmailChangePage } from './modules/auth/presentation/pages/ConfirmEmailChangePage';
import { HandoffPage } from './pages/handoff-page';
import { AuthorizePage } from './pages/authorize-page';
import { PlatformsPage } from './modules/platforms/presentation/pages/PlatformsPage';
import { PlatformPerksPage } from './modules/platforms/presentation/pages/PlatformPerksPage';

export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/sign-in" element={<SignInPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route
        path="/change-password-required"
        element={<ChangePasswordRequiredPage />}
      />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/change-email/submit" element={<SubmitNewEmailPage />} />
      <Route
        path="/change-email/confirm"
        element={<ConfirmEmailChangePage />}
      />
      <Route path="/handoff" element={<HandoffPage />} />
      {/* Login global (SSO iniciado pelo destino) — pública: quem chega aqui
          ainda não tem sessão, e os gates rodam no scope do destino. */}
      <Route path="/authorize" element={<AuthorizePage />} />

      {/* Protected routes */}
      <Route
        element={
          <AuthGuard>
            <AppLayout />
          </AuthGuard>
        }
      >
        <Route path="/" element={<Navigate to="/profile" replace />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/platforms" element={<PlatformsPage />} />
        <Route
          path="/platforms/:platformProfileId/perks"
          element={<PlatformPerksPage />}
        />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="*" element={<Navigate to="/profile" replace />} />
      </Route>
    </Routes>
  );
}
